import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const version = process.env.REACT_APP_VERSION || '1.0.0';
  const buildNumber = process.env.REACT_APP_BUILD || '1';

  return (
    <footer className="bg-dark-card border-t border-dark-border py-3 px-4 sm:px-8 relative"
            style={{
              background: '#141414',
            }}>
      <div className="flex items-center justify-between text-gray-600 text-xs sm:text-sm relative z-10">
        <p style={{ textShadow: '0 0 5px rgba(178, 75, 243, 0.2)' }}>
          v{version}.{buildNumber}
        </p>
        <p style={{ textShadow: '0 0 5px rgba(178, 75, 243, 0.2)' }}>
          © {currentYear} Echostar Corp. All rights reserved.
        </p>
        <div className="w-16" />
      </div>
    </footer>
  );
};

export default Footer;

